<div class="overlay"></div>
<div
  class="wrapper noShow"
  [ngClass]="{
    large: size === dialogSize.Large,
    fullScreen: size === dialogSize.FullScreen,
    'behavior-mobile': behavior === dialogBehavior.DesktopMobile
  }"
  >
  @if (size === dialogSize.FullScreen) {
    <daui-button
      [id]="id + '-dialog-fullscreen-close'"
      class="fullscreenExit"
      [icon]="buttonIcon.FullScreenExit"
      [type]="buttonType.Flat"
      [attractive]="buttonAttractive.Regular"
      (click)="onExit()"
    ></daui-button>
  }
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
